/** @module MaterialSpec/ThemePlacements */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/underscore",
	"csi/def/Actions",
	"csi/def/Action",
	"csi/def/Request",
	"csi/def/ViewRef",
	"csi/locale",
	"csi/xml",
	"csi/xml/Query",
	"csi/widget/MessageDialog",
	"Specification/BOM/DeleteSectionController",
	"Specification/BOM/EditSectionController",
	"Specification/BOM/PlacementTable"
], function(declare, lang, csi, _, Actions, Action, Request, ViewRef, locale, xml, Query, MessageDialog
	, DeleteSectionController, EditSectionController, PlacementTable) {

	var ACTION_EDIT = "BomSectionEdit";
	var ACTION_DELETE = "BomSectionDelete";

	return declare(PlacementTable, {
		newActionsButtonResource: "Create",

		/** @property {string[]} bomActiveColorURLs - list of color colorway URLs selected to display */
		bomActiveColorURLs: null,

		/** @property {Nodes} bomColorStore - store containing list of available colors */
		bomColorStore: null,

		/** Additional actions to be shown on "No Results" placeholder */
		placeholderActions: ["BomSectionMenuSelect", "BomSectionMenuCreate"],

		// Actions: actions for DSSection groups
		_bomSectionActions: null,

		// To support the aggregation view of the Style BOM "New from Theme Placement" action: if defined, display only this one section
		_sectionToDisplay: null,

		/**
		 * Initialize newActionsButtonGroups
		 */
		postCreate: function() {
			this.newActionsButtonGroups = [locale.typePlural("PartMaterial"), locale.resource("Sections")];

			this.inherited(arguments);
		},

		/*
		 * reset active color colorways when custom view is changed
		 */
		onChangeCustomView: function() {
			this.set("bomActiveColorURLs", null);
			this.set("bomColorStore", null);
			this.inherited(arguments);
		},

		_createQueryLevel: function(/*Object*/params, /*Boolean*/bRoot) {
			// summary: filter out items that do not apply to selected product alternative
			var ql = this.inherited(arguments);
			if (ql.bMain) {
				var q = new Query();

				this._addProductAlternativeQuery(q);

				if (!q.isEmpty()) {
					ql.serverQuery = q;
				}
			}

			if (ql.groupSpec && ql.groupSpec.heading.m_id == "DSSection") {
				ql.actions = this._bomSectionActions;
				var allSections = this._sectionToDisplay ? [this._sectionToDisplay] : this.getViewNode().AllSections;
				ql.groupDefaultsStore = (this.defView.m_formData) ? null : this._getGroupDefaultsStore(allSections, this.cacheView);
			}

			return ql;
		},

		_getNoResultDescription: function(hasColumnFilter, hasNewAction) {
			if (!hasColumnFilter && hasNewAction) {
				return locale.resource("ViewPlaceholderDescriptionNoResultForThemePlacements");
			}

			return this.inherited(arguments);
		},


		/**
		 * C8-3258:  Inline Delete action of BOM Section on Theme
		 * C8-38760: Don't allow deleting when this table is a popup from an aggregate action
		 */
		_resolveView: function() {
			if (this.defView.shouldAllowActions()) {
				// prepare actions for DSSection group if user has admin rights on the parent node
				var deleteBOMRequest = lang.mixin(new Request(), {m_module: "Specification", m_operation: "DeleteBOMSectionDefinitions"});

				this._bomSectionActions = _.extend(new Actions(), {
					m_actions: [
						this.defView._addViewAction(ACTION_EDIT, {
							classController: EditSectionController,
							m_viewRef: lang.mixin(new ViewRef(), {
								m_id: "AdHocForm"
							}),
							m_accessAction: "_accessActionEditSection"
						}),

						this.defView._addViewAction(ACTION_DELETE, {
							classController: DeleteSectionController,
							confirmAction: MessageDialog.BUTTON_DELETE,
							m_accessAction: "_accessActionDeleteSection",
							m_request: deleteBOMRequest
						})
					]
				});
			}

			this.inherited(arguments);
		},

		/**
		 * Ensure that selected colors are still in store when store is set
		 * @param {Names} store
		 */
		_setBomColorStoreAttr(store) {
			this._set("bomColorStore", store);

			const {bomActiveColorURLs} = this;
			if (bomActiveColorURLs) {
				const urls = bomActiveColorURLs.filter((url) => store && store.get(url));

				if (urls.length !== bomActiveColorURLs.length) {
					this._set("bomActiveColorURLs", urls);
				}
			}
		},

		getPrintProperties: function() {
			// summary: return object containing properties from view necessary to recreate it for printing that are not custom view options
			var params = this.inherited(arguments);
			params.bomActiveColorURLs = this.bomActiveColorURLs;
			return params;
		}
	});
});
